import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const Requirements = ({ items }) => (
  <ul className="space-y-3">
    {items.map((item, index) => {
      // Split on backticks to separate the emphasized part from the rest
      const parts = item.split(/`([^`]+)`/);
      // If there are no backticks, parts will just have one item
      const formattedText = parts.map((part, i) => {
        // Even indices are normal text, odd indices were between backticks
        return i % 2 === 1 ? (
          <span key={i} className="font-semibold text-gray-800">
            {part}
          </span>
        ) : (
          part
        );
      });

      return (
        <li key={index} className="flex items-start">
          <CheckCircleIcon className="h-6 w-6 text-green-500 flex-shrink-0" />
          <span className="ml-3 text-gray-600">
            {formattedText}
          </span>
        </li>
      );
    })}
  </ul>
);

export default Requirements;
